export default "__VITE_ASSET__BQGCl9qj__"